<template>
    <load-content :loading="isBusy">
        <div class="tags-usage-report">
            <div class="filters-articles-list d-flex"> 
                <articles-filter-date
                    :title="$t('articles.form.filter_date.title')"
                    :from.sync="filters.dateFrom"
                    :to.sync="filters.dateTo"
                    :type.sync="filters.dateType"
                    :onChange="onChangeDateFilters"
                    class="mr15"
                />

                <div 
                    class="btn btn-carma btn-square mt10 mb10" 
                    @click="onExport"
                >
                    <i class="fas fa-download" aria-hidden="true"></i> Export
                </div>
            </div>
            <load-content :loading="isUsageReportBusy">
                <div class="card">
                    <datatable 
                        ref="tagstable"
                        :data="datatable"
                    />
                    <div  class="loading-next-page" v-if="isUsageReportPaginationBusy"><loader /></div>
                </div>
            </load-content>
        </div>
    </load-content>
</template>

<script>
    import { mapState, mapActions } from "vuex";
    import Datatable from '../datatable';
    import LoadContent from '../load-content';
    import Loader from "../../components/loader";
    import { download_blob } from "../../helpers/download_file";
    import { ARTICLES } from "../../config/const";
    import ArticlesFilterDate from "../../components/coding-admin/articles-filter-date";
    import moment from "moment";
    export default {
        name: 'TagsUsageReport',
        components:{
            ArticlesFilterDate,
            Datatable,
            LoadContent,
            Loader
        },
        data(){
            const dateToDefault = moment.utc().format('YYYY-MM-DD');
            const dateFromDefault = moment.utc().subtract(1, 'month').format('YYYY-MM-DD');

            return {
                filters: {
                    dateFrom: dateFromDefault,
                    dateTo: dateToDefault,
                    dateType: ARTICLES.FILTERS.PUBLISHED_AT,
                },
                pagination: {
                    page: 1,
                    perPage: 20,
                    order: "count_articles",
                    sort: "desc"
                },
            }
        },
        created(){
            this.fetchTags();
            this.scroll();
        },
        computed: {
            ...mapState({
                isBusy: state => state.projectSetup.projectSetup.isBusy,
                isUsageReportBusy: state => state.projectSetup.projectSetup.isUsageReportBusy,
                isUsageReportPaginationBusy: state => state.projectSetup.projectSetup.isUsageReportPaginationBusy,
                user: state => state.user.user.data || {},
                project: state => state.projects.project.data,
                tags: state => state.projectSetup.projectSetup.data?.tags,
                tagsPagination: state => state.projectSetup.projectSetup.data?.tagsPagination
            }),
            currentTags(){
                return this.tags || [];
            },
            columns() {
                return [
                    {
                        key: 'pos',
                        label: ""
                    },
                    {
                        key: 'category',
                        label: "Category",
                        orderable: true
                    },
                    {
                        key: 'tag',
                        label: "Tag",
                        orderable: true
                    },
                    {
                        key: 'cat_id',
                        label: "Category ID",
                        orderable: true
                    },
                    {
                        key: 'tag_id',
                        label: "Tag ID",
                        orderable: true
                    },
                    {
                        key: 'count_articles',
                        label: "Articles Count",
                        orderable: true
                    },
                ];
            },
            datatable() {
                const self = this;
                return {
                    resizable: true,
                    columns: self.columns,
                    body: self.currentTags,
                    order: {
                        column: self.pagination.order,
                        direction: self.pagination.sort,
                        onChange: function(column, direction) {
                            self.onSortTable({ order: column, sort: direction });
                        }
                    },
                }
            },
        },
        methods:{
            ...mapActions({
                getTagsUsageReport: "projectSetup/getTagsUsageReport"
            }),

            fetchTags(){
                const self = this;
                const { dateType, dateFrom, dateTo } = this.filters
                this.getTagsUsageReport({
                    projectId: this.project.project_id, 
                    filters: { dateType, dateFrom, dateTo },
                    pagination: this.pagination
                }).then( () =>{
                    if (self.pagination.page === 1){
                        self.updatePagination(); //if window is higher than content pagination is updated
                    }
                })
            },

            onChangeDateFilters(){
                this.resetPagination();
                this.fetchTags();
            },


            resetPagination(){
                this.pagination.page = 1;
            },

            getNextPage(){
                if (!this.isUsageReportPaginationBusy && this.pagination.page < this.tagsPagination?.totalPages){
                    this.pagination.page ++;
                    this.fetchTags();  
                }
            },

            updatePagination(){
                if (this.isUsageReportPaginationBusy) return
                if (this.$refs.tagstable) {
                    const wHeight = window.innerHeight;
                    const { top, bottom, height } = this.$refs.tagstable.$el.getBoundingClientRect();
                    const margin = 100;

                    if ((top * (-1) + wHeight >= height - margin)) {
                        this.getNextPage();
                    }
                }

            },

            onExport() {
                const user = this.user;
                const { dateType, dateFrom, dateTo } = this.filters;
                const projectId = this.project.project_id;
                const pagination = {...this.pagination};
                pagination.perPage = 'ALL';
                
                const data = {
                    projectId: projectId, 
                    filters: { dateType, dateFrom, dateTo },
                    pagination: pagination,
                    columns: this.columns.map(c => c.label),
                    columnsOrder: this.columns.map(c => c.key)
                }
                const fileName = `TAGS_Usage_Report_${Date.now()}`;

                download_blob(`analysis/${projectId}/export/usage-report`, data, user.accessToken, fileName)
                    //.then(r => {})
                    .catch(error => {
                        console.error(error);
                        this.exporting = false;
                        this.$notify({
                            group: "store_notifications",
                            type: "error",
                            text: this.$t("messages.request.error")
                        });
                    });
            },

            onSortTable: async function({order, sort}) {
                this.pagination = {
                    order: order,
                    sort: sort,
                    page: 1,
                    perPage: this.pagination.perPage
                }
                this.fetchTags();
            },

            scroll(){
                window.onscroll = () => {
                    this.updatePagination();
                } 
            },
        },
        watch: {
            'filters.dateType'(){
                this.onChangeDateFilters();
                this.resetPagination();
            },
            'filters.dateFrom'(){
                this.onChangeDateFilters();
                this.resetPagination();
            },
            'filters.dateTo'(){
                this.onChangeDateFilters();
                this.resetPagination();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/coding-admin/_tags.scss";
    @import "../../styles/components/_datatable_bulk_actions.scss";

    .table-outer {
      overflow: inherit;
    }

    .filters-articles-list{
        justify-content: space-between;
        align-items: flex-end;
    }
</style>